import authRoles from "core/auth/authRoles";
import { lazy } from "react";
const Credentials = lazy(() => import("./Credentials"));

const credentialsConfig = {
  component: Credentials,
  path: "/credentials",
  exact: false,
  layout: {
    config: {
      navbar: {
        display: true,
      },
      sidebar: {
        display: true,
      },
      midbar: {
        display: true,
      },
      footer: {
        display: true,
      },
    },
  },
  auth: authRoles.organization,
  protected: true,
};

export default credentialsConfig;
